import ADVERTISERS_API from 'api/advertisers/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'
import {
  GET_LIST,
  // REMOVE_FROM_LIST,
  SET_DATA,
  SET_ITEM_DATA,
  SET_LOADING,
  SET_STATUS,
} from 'modules/Advertisers/List/types'

function* getAdvertisers({ payload }) {
  try {
    yield put({
      type: SET_LOADING,
      payload: { loading: true },
    })

    const { response, error } = yield call(ADVERTISERS_API.fetchAll, {
      params: payload.params,
    })

    if (error) {
      throw error
    }

    const { data, pagination } = response

    yield put({
      type: SET_DATA,
      payload: {
        data,
        pagination,
      },
    })
  } catch (error) {
    yield put({
      type: SET_LOADING,
      payload: { loading: false },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_LOADING,
      payload: { loading: false },
    })
  }
}

function* setStatus({ payload }) {
  try {
    const { response, error } = yield call(
      payload.status !== 'active'
        ? ADVERTISERS_API.activate
        : ADVERTISERS_API.archive,
      {
        id: payload.id,
      },
    )

    if (response?.status === 200) {
      yield put(
        notificationShow({
          type: 'success',
          message: `advertisers::notifications.${
            payload.status === 'active' ? 'archive' : 'activate'
          }_success`,
        }),
      )

      yield put({
        type: SET_ITEM_DATA,
        payload: {
          ...payload,
          status: payload.status === 'active' ? 'archived' : 'active',
        },
      })
    }

    if (error) {
      throw error
    }

    /* yield put({
      type: REMOVE_FROM_LIST,
      payload: {
        id: payload.id,
      },
    })*/
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: `advertisers::notifications.${
          payload.status === 'active' ? 'archive' : 'activate'
        }_failed`,
      }),
    )
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(GET_LIST, getAdvertisers)
  yield takeLatest(SET_STATUS, setStatus)
}
